import * as React from "react";
import { createValidator } from "not-valid";

import { BaseInput, SharedProps } from "../base-input";
import { timeRegex } from "./timeRegex";

export interface TimeInputProps extends SharedProps<string> {}

export class TimeInput extends React.Component<TimeInputProps> {

    public render() {
        const DateBaseInput = BaseInput as unknown as new () => BaseInput<string>;

        const validator = createValidator<string>(v => v !== undefined && timeRegex.test(v), "Please enter a valid time");

        return (
            <DateBaseInput
                defaultValue={""}
                getValueFromInput={this.getValueFromInput}
                type="time"
                requiredValidator={validator}
                {...this.props}
            />
        );
    }

    private getValueFromInput = (value: string) => value;
}
